import { StreakNotificationDispatch, StreakNotificationComponent } from '@tryhackme/thm-ui-components';
import { streakMilestonesInDays } from './streak-notification.constants';
export const displayStreakNotification = (updatedStreak: number, largestStreak = 0) => {
  const highestMilestone = Math.max(...streakMilestonesInDays);
  if (updatedStreak > highestMilestone) return;
  const streakMilestonesYetToBeReachedByUser = streakMilestonesInDays.filter(milestone => milestone > largestStreak);
  let userStreakMilestoneInfo: {
    isUpdatedStreakAtMilestone: boolean | undefined;
    lastMilestone: number | undefined;
    nextMilestone: number | undefined;
  } = {
    isUpdatedStreakAtMilestone: false,
    lastMilestone: 0,
    nextMilestone: 0
  };
  for (const [index, milestone] of streakMilestonesYetToBeReachedByUser.entries()) {
    if (updatedStreak - milestone === 0) {
      userStreakMilestoneInfo = {
        isUpdatedStreakAtMilestone: true,
        lastMilestone: milestone,
        nextMilestone: streakMilestonesYetToBeReachedByUser[index + 1]
      };
      break;
    }
    if (updatedStreak - milestone < 0) {
      userStreakMilestoneInfo = {
        isUpdatedStreakAtMilestone: false,
        lastMilestone: streakMilestonesYetToBeReachedByUser[index - 1],
        nextMilestone: milestone
      };
      break;
    }
  }
  const {
    isUpdatedStreakAtMilestone,
    lastMilestone,
    nextMilestone
  } = userStreakMilestoneInfo;
  let message = '';
  if (updatedStreak === 1) message = largestStreak > streakMilestonesInDays[0]! ? `You've started a hacking streak. Keep it going!` // if the user already has the 7 (first streak milestone) day streak badge
  : `You've started a hacking streak. Keep it going for ${streakMilestonesInDays[0]! - 1} days for a badge!`;else if (isUpdatedStreakAtMilestone && lastMilestone) {
    // this block is for when the user's streak is at a streak milestone
    message = nextMilestone ? `You've earned the ${lastMilestone} day Streak badge! ${nextMilestone} next?` : `You've earned the ${lastMilestone} day Streak badge!`; // when the user earns the 1500 day streak badge
  } else if (!isUpdatedStreakAtMilestone && nextMilestone) {
    // this block is for when the user's streak is not at a streak milestone
    const remaining = nextMilestone - updatedStreak;
    const streakString = remaining === 1 ? 'streak' : 'streaks';
    message = remaining < 10 ? `Your streak has increased. You're ${remaining} ${streakString} away from a badge!` : `Your streak has increased! You're closer to your next badge of ${nextMilestone} days. Keep up the amazing work!`;
  }
  StreakNotificationDispatch('success', <StreakNotificationComponent streak={updatedStreak} message={message} />);
};